    

    jQuery(document).ready(function (){
        jQuery(".PwzrGrid-root [role=button][class*='PwzrButton-root-']").on("click", function(){
                history.pushState(null, "", location.href);         
        });
    });

 
	window.onpopstate = function() {
		window.location.reload();
	}	
